import * as React from 'react';

import ProgramCurriculum from 'bundles/internal-enterprise/components/ProgramCurriculum';
import Naptime from 'bundles/naptimejs';
import EnterpriseProgramsV1 from 'bundles/naptimejs/resources/enterprisePrograms.v1';
import ProgramCurriculumsV1 from 'bundles/naptimejs/resources/programCurriculums.v1';
import ProgramMembershipsV2 from 'bundles/naptimejs/resources/programMemberships.v2';

import _t from 'i18n!nls/internal-enterprise';

import 'css!./__styles__/EnterpriseToolsHome';

type PropsFromCaller = {
  params: { userId: string };
};

type PropsFromNaptime = {
  programMemberships: Array<ProgramMembershipsV2>;
};
type PropsFromNaptime2 = {
  programs: Array<EnterpriseProgramsV1>;
};
type PropsFromNaptime3 = {
  curriculums: Array<ProgramCurriculumsV1>;
};
type Props = PropsFromCaller & PropsFromNaptime & PropsFromNaptime2 & PropsFromNaptime3;

class CurriculumManager extends React.Component<Props> {
  render() {
    const {
      programs,
      curriculums,
      params: { userId },
      programMemberships,
    } = this.props;

    const emailNotVerified = programMemberships.some((p) => p.membershipState === 'INVITED_EMAIL_NOT_VERIFIED');

    return (
      <div className="rc-CurriculumManager">
        {emailNotVerified && (
          <div className="alert alert-warning">
            <strong>{_t('Warning!')}&nbsp;</strong>
            {_t(
              "Learner email is not verified for at least one program. The learner's invited email must be verified before joining a program."
            )}
          </div>
        )}
        {programs.map((program) => {
          const curriculum = curriculums.find((c) => c.id === program.curriculumId);
          return (
            curriculum && (
              <ProgramCurriculum key={program.id} program={program} curriculum={curriculum} userId={userId} />
            )
          );
        })}
      </div>
    );
  }
}

const WithCurriculums = Naptime.createContainer<Props, PropsFromCaller & PropsFromNaptime & PropsFromNaptime2>(
  CurriculumManager,
  ({ programs = [] }) => ({
    curriculums: ProgramCurriculumsV1.multiGet(
      programs.map((p) => p.curriculumId),
      {
        params: {
          includeClips: true,
        },
      }
    ),
  })
);

const WithPrograms = Naptime.createContainer<
  PropsFromCaller & PropsFromNaptime & PropsFromNaptime2,
  PropsFromCaller & PropsFromNaptime
>(WithCurriculums, ({ programMemberships = [] }) => ({
  programs: EnterpriseProgramsV1.multiGet(
    programMemberships.map((p) => p.programId),
    {
      fields: ['id', 'metadata', 'curriculumId'],
    }
  ),
}));

export default Naptime.createContainer<PropsFromNaptime & PropsFromCaller, PropsFromCaller>(({ params }) => ({
  programMemberships: ProgramMembershipsV2.finder('byUser', {
    params: { userId: params.userId },
    includes: ['enterprisePrograms'],
    subcomponents: [WithPrograms],
  }),
}))(WithPrograms);
